/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Toggle_MenuInputs */

const en_nav_toggle_menu = /** @type {(inputs: Nav_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle mobile menu`)
};

const es_nav_toggle_menu = /** @type {(inputs: Nav_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar menú móvil`)
};

/**
* | output |
* | --- |
* | "Toggle mobile menu" |
*
* @param {Nav_Toggle_MenuInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_toggle_menu = /** @type {((inputs?: Nav_Toggle_MenuInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Toggle_MenuInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_toggle_menu(inputs)
	return en_nav_toggle_menu(inputs)
});